import React from 'react';
import styled from '@emotion/styled';
import { spacing } from '@mui/system';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { Divider, Grid, Paper as MuiPaper, Toolbar } from '@mui/material';
import TableFilterToolbar from '../../../components/tables/TableFilterToolbar';
import { filterStatuses, getQuoteStatus } from '../utils/quoteUtils';
import QuoteTable from './QuoteTable';
import QuoteCardList from './QuoteCardList';
import { QuoteListProps } from '../quoteTypes';

const Paper = styled(MuiPaper)(spacing);

function QuoteFilteredList({ isLoading, rows, hasRoles, backOfficeRootUrl }: QuoteListProps) {
  const [rowFilter, setRowFilter] = React.useState<string[]>([]);

  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const filteredRows = rowFilter.length > 0 ? rows.filter((row) => rowFilter.includes(getQuoteStatus(row))) : rows;

  const handleStatusFilter = (filters: string[]) => {
    setRowFilter(filters);
  };

  return (
    <Paper>
      <Toolbar>
        <Grid container>
          <Grid item xs={12} lg={10} xl={9} pr={3}>
            <TableFilterToolbar options={filterStatuses} onFilterChange={handleStatusFilter} label="Quote status" />
          </Grid>
        </Grid>
      </Toolbar>
      <Divider sx={{ mt: 1, mb: 0 }}></Divider>
      {isSmUp && <QuoteTable isLoading={isLoading} rows={filteredRows} backOfficeRootUrl={backOfficeRootUrl} hasRoles={hasRoles} />}
      {!isSmUp && <QuoteCardList isLoading={isLoading} rows={filteredRows} backOfficeRootUrl={backOfficeRootUrl} hasRoles={hasRoles} />}
    </Paper>
  );
}

export default QuoteFilteredList;
